import React from 'react';
import { Toggle } from '@ofself/shell';
import './Switch.css';

// THE SWITCH is the shell's own Toggle (@ofself/shell 0.306): a square knob with
// grip ridges that snaps over, stretches while pressed and follows a drag. Nucleus
// adds only its section's hue and the face below (Switch.css).
export const Switch = Toggle;

/** The switch's face alone, for a row that is itself the button (role="switch" on the row). */
export { SwitchFace } from './SwitchFace';

export default Switch;
